import { ICartLicense } from '../../tn.common';

export function cartLicenseIsUpgrade(
    license: ICartLicense,
    key: string
): boolean {
    const right = license.fontRights[key];
    return right && right.upgrade === true;
}
